import React from "react";
import { Hero } from "./sections/01_Hero";
import { Services } from "./sections/02_Services";
import { AiFirst } from "./sections/03_AiFirst";
import { Understanding } from "./sections/04_Understanding";
import { Process } from "./sections/05_Process";
import { IoT } from "./sections/06_IoT";
import { References } from "./sections/07_References";
import { Values } from "./sections/08_Values";
import { Contact } from "./sections/09_Contact";
import { Footer } from "./sections/10_Footer";

import "./Home.css";

export const Home: React.FC = () => {
  return (
    <div id="home" className="h-screen">
      <Hero />
      <Services />
      <AiFirst />
      <Understanding />
      <Process />
      <IoT />
      <References />
      <Values />
      <Contact />
      <Footer />
    </div>
  );
};
